/**
 * The CW quote object has different keys depending on if it came from their server side API or client side. This will return an object that always resembles the client side API
 * @param {Object} quote The CW quote
 * @returns Object
 */
export default function(quote) {
    const remap = {
        AllInclusiveRegularPayment: 'TotalRegularPayment',
        CashPrice: 'TotalPrice',
        CustomerRate: 'RateOfInterest',
        TotalAmountOfCharges: 'ChargesForCredit',
        AmountOfCredit: 'Balance',
        TotalChargeForCredit: 'ChargesForCredit',
    };

    let normalizedQuote = quote;
    Object.keys(remap).forEach(key => {
        if (typeof quote.Quote[key] != 'undefined') {
            return;
        }
        if (typeof quote.Quote[remap[key]] == 'undefined') {
            return;
        }

        normalizedQuote.Quote[key] = quote.Quote[remap[key]];
    });

    if (typeof quote.Quote.Deposit == 'undefined' && typeof quote.Quote.Deposit.Cash != 'undefined') {
        normalizedQuote.Quote.Deposit = quote.Quote.Deposit.Cash;
    }
    if (typeof quote.Quote.CashDeposit == 'undefined' && typeof quote.Quote.Deposit.Cash != 'undefined') {
        normalizedQuote.Quote.CashDeposit = quote.Quote.Deposit.Cash;
    }
    if (typeof quote.Quote.Settlement == 'undefined' && typeof quote.Quote.Deposit.Settlement != 'undefined') {
        normalizedQuote.Quote.Settlement = quote.Quote.Deposit.Settlement;
    }
    if (typeof quote.Quote.PartExchange == 'undefined' && typeof quote.Quote.Deposit.PartExchange != 'undefined') {
        normalizedQuote.Quote.PartExchange = quote.Quote.Deposit.PartExchange;
    }
    if (typeof quote.Quote.DepositContribution == 'undefined' && typeof quote.Quote.Deposit.RetailerContribution != 'undefined') {
        normalizedQuote.Quote.DepositContribution = quote.Quote.Deposit.RetailerContribution;
    } else if (typeof quote.Quote.DepositContribution == 'undefined' && typeof quote.Quote.Deposit.ManufacturerContribution != 'undefined') {
        normalizedQuote.Quote.DepositContribution = quote.Quote.Deposit.ManufacturerContribution;
    }

    return normalizedQuote;
}